"use client";

import React, { useState } from 'react';
import CircleSequence from './CircleSequence';



const OutputVisualization = ({
  sequence,
  positionToShow=0,
  totalPoints=250
}) => {
  const [sequenceInput, setSequenceInput] = useState('');
  const [lineWidth,setLineWidth]=useState(0.19)
  const [percentToShow,setPercentToShow]=useState(100)
  const [isPreviewingFinal, setIsPreviewingFinal] = useState(false);

  const effectivePosition = isPreviewingFinal ? (sequence ? sequence.length : 0) : positionToShow;

  return (
    <div className="flex-1 bg-white shadow-lg rounded-2xl w-full flex flex-col overflow-hidden">
      {/* Circle Sequence Visualization */}
      <div 
        className="flex-1 w-full flex justify-center items-center min-h-0 cursor-pointer select-none"
        onMouseDown={() => setIsPreviewingFinal(true)}
        onMouseUp={() => setIsPreviewingFinal(false)}
        onMouseLeave={() => setIsPreviewingFinal(false)}
        onTouchStart={() => setIsPreviewingFinal(true)}
        onTouchEnd={() => setIsPreviewingFinal(false)}
        onContextMenu={(e) => { e.preventDefault(); e.stopPropagation(); }}
        style={{ WebkitTouchCallout: 'none', WebkitUserSelect: 'none' }}
      >
        <CircleSequence
          sequence={sequence}
          totalPoints={totalPoints}
          lineWidth={lineWidth}
          positionToShow={effectivePosition}
          percentToShow={percentToShow}
        />
      </div>
      
      {/* Controles Compactos */}
      <div className="bg-gray-800 text-white p-2 flex flex-row items-center gap-3 text-xs sm:text-sm">
        {/* Line Width Control */}
        <div className="flex-1 flex items-center gap-2 min-w-0">
          <label htmlFor="line-width" className="whitespace-nowrap flex items-center gap-1">
            <span>📏</span>
            <span className="hidden sm:inline">Grosor:</span>
            <span className="font-mono w-10">{lineWidth.toFixed(2)}</span>
          </label>
          <input
            type="range"
            id="line-width"
            min="0.01"
            max="0.5"
            step="0.01"
            value={lineWidth}
            onChange={(e) => setLineWidth(Number(e.target.value))}
            className="flex-1 h-2 bg-gray-600 rounded-lg appearance-none cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
};

export default OutputVisualization;
